import { ChangeEvent } from "react";

import {
  ProductsTable,
  ItemLine,
  CodColumn,
  QtdColumn,
  NoQtdColumn,
  VlrColumn,
} from "../../styles/common";
import ProductName from "../ProductName";
import ProductInfo from "../ProductInfo";
import { DelColumn, TotalsRow, LabelColumn } from "./styles";
import OrderItem from "../../types/OrderItem";
import { ItemToSendSimple } from "../../types/ItemToSend";

interface OrderItemsListProps {
  loading: boolean;
  items: OrderItem[];
  perfumaria: number | string;
  medicamentos: number | string;
  liquid: number | string;
  total: number | string;
  itemsToSend: ItemToSendSimple[];
  minimumReached: boolean;
  setQt: (item: OrderItem, qtd: number) => void;
  delItem: (item: OrderItem, event: ChangeEvent<HTMLInputElement>) => void;
}

const OrderItemsList = ({
  loading,
  items,
  perfumaria,
  medicamentos,
  liquid,
  total,
  itemsToSend,
  minimumReached,
  setQt,
  delItem,
}: OrderItemsListProps) => (
  <ProductsTable>
    <thead>
      <tr>
        <th>Cód.</th>
        <th>Inf.</th>
        <th>Mercadoria</th>
        <th>Qtd</th>
        <th>Preço líq.</th>
        <th>Imposto</th>
        <th>Preço final</th>
        <th>Excluir</th>
      </tr>
    </thead>
    <tbody>
      {!loading &&
        items.map(item => {
          let qty = item.qt_pedida;

          for (let i = 0; i < itemsToSend.length; i += 1) {
            const itemToSend = itemsToSend[i];
            if (itemToSend && item.cd_mercadoria === itemToSend.cd_mercadoria) {
              qty = Number(itemToSend.qtd) || 0;
              break;
            }
          }

          let qtDisponivel: number | null = null;
          let maxQtd: number | null = null;

          if (item.mercadoria.bloqueio) {
            qtDisponivel = item.mercadoria.bloqueio
              ? item.mercadoria.bloqueio.qt_disponivel
              : null;
            maxQtd = (qtDisponivel ? qtDisponivel : 0) - qty;
          }
          return (
            <ItemLine
              key={item.cd_mercadoria}
              $bloqueio={!!item.mercadoria.bloqueio}
            >
              <CodColumn>{`${item.mercadoria.full_cd_mercadoria}`}</CodColumn>
              <td>
                <ProductInfo product={item.mercadoria} />
              </td>
              <td>
                <ProductName product={item.mercadoria} />
              </td>
              {item.mercadoria.infos.id_falta === "N" ? (
                <QtdColumn
                  $estoqueBaixo={
                    item.mercadoria.infos.qt_fisica -
                      item.mercadoria.infos.qt_reservada <=
                    15
                  }
                >
                  <input
                    onChange={event =>
                      setQt(item, parseInt(event.target.value, 10) || 0)
                    }
                    type="number"
                    value={qty}
                    max={maxQtd || undefined}
                    min={0}
                  />
                </QtdColumn>
              ) : (
                <NoQtdColumn>---</NoQtdColumn>
              )}

              <VlrColumn>{`${item.mercadoria.infos.vl_preco_liq_formated}`}</VlrColumn>
              <VlrColumn>{`${item.mercadoria.infos.vl_imposto_formated}`}</VlrColumn>
              <VlrColumn>{`${item.mercadoria.infos.vl_total_formated}`}</VlrColumn>
              <DelColumn>
                <input
                  onChange={event => delItem(item, event)}
                  type="checkbox"
                />
              </DelColumn>
            </ItemLine>
          );
        })}
    </tbody>
    <tfoot>
      <TotalsRow>
        <LabelColumn>Total de perfumaria:</LabelColumn>
        <VlrColumn>{perfumaria}</VlrColumn>
      </TotalsRow>
      <TotalsRow>
        <LabelColumn>Total de medicamentos:</LabelColumn>
        <VlrColumn>{medicamentos}</VlrColumn>
      </TotalsRow>
      <TotalsRow className={!minimumReached ? "minimumNotReached" : ""}>
        <LabelColumn>Total líquido:</LabelColumn>
        <VlrColumn>{liquid}</VlrColumn>
      </TotalsRow>
      <TotalsRow>
        <LabelColumn>Total com impostos:</LabelColumn>
        <VlrColumn>{total}</VlrColumn>
      </TotalsRow>
    </tfoot>
  </ProductsTable>
);

export default OrderItemsList;
